import { render, staticRenderFns } from "./laplaceJztCourse.vue?vue&type=template&id=1e545804&scoped=true"
import script from "./laplaceJztCourse.vue?vue&type=script&lang=js"
export * from "./laplaceJztCourse.vue?vue&type=script&lang=js"
import style0 from "./laplaceJztCourse.vue?vue&type=style&index=0&id=1e545804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e545804",
  null
  
)

export default component.exports